import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { typography } from '@cld/typography';

const borderWidth = '2px';

export const Link = styled.div`
  ${typography.sm.highContrast};
  display: block;
  padding: ${borderWidth} ${globalTheme.spacing.sm} 0;
  line-height: calc(2 * ${globalTheme.spacing.lg} + ${globalTheme.spacing.xs});

  &:hover,
  &.selected {
    border-bottom: solid ${borderWidth} ${globalTheme.palette.brand.accentCoral};
    color: ${globalTheme.palette.brand.accentCoral};
  }
`;
